export const ServicesTableColumns = (isArabic) => [
    { id: 'name',       label: isArabic ? 'الاسم'         : 'Name',       align: 'start'  },
    { id: 'slug',       label: isArabic ? 'الرابط (Slug)' : 'Slug',       align: 'start'  },
    { id: 'price',      label: isArabic ? 'السعر'         : 'Price',      align: 'start'  },
    { id: 'is_active',  label: isArabic ? 'الحالة'        : 'Status',     align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start'  },
];